export class FavoriteStorage {
    private _storageKey: string;
    private static _instances: { [key: string]: FavoriteStorage };

    constructor(storageKey: string) {
        FavoriteStorage._instances = FavoriteStorage._instances || {};

        if (storageKey in FavoriteStorage._instances) {
            return FavoriteStorage._instances[storageKey];
        }
        FavoriteStorage._instances[storageKey] = this;
        this._storageKey = storageKey;
    }

    isFavorite(id: string): boolean {
        return this.getFavorites().indexOf(id) > -1;
    }

    addToStorage(id: string | number): void {
        const storeValue = this.getFavorites();
        storeValue.push(id.toString());
        this.storeFavorites(storeValue);
    }

    removeFromStorage(id: string): void {
        const storeValue = this.getFavorites();
        this.storeFavorites(storeValue.filter((i) => i !== id));
    }

    getFavorites(): string[] {
        return localStorage[this._storageKey] ? (JSON.parse(localStorage[this._storageKey]) as string[]) : [];
    }

    storeFavorites(value: string[]): void {
        localStorage[this._storageKey] = JSON.stringify(value);
    }
}
